<template>
    <div class="modal fade" id="departmentAdd" tabindex="-1" role="dialog" aria-labelledby="departmentAdd"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Add Department</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper ">
                        <div class="col-sm-12">
                            <div class="row g-3">
                                <div class="col-md-12 position-relative">
                                    <label class="form-label">Department Name</label>
                                    <input class="form-control" type="text" v-model="dept.name"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Department Status</label>
                                    <select class="form-select" required="" v-model="dept.status">
                                        <option selected="" disabled="" value="">Choose...</option>
                                        <option value="1">Active</option>
                                        <option value="2">De-Active</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12">
                        <button class="btn btn-primary" @click="save_dept">Add Department</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="employeeAdd" tabindex="-1" role="dialog" aria-labelledby="employeeAdd"
        aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Add Employee</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper">
                        <div class="col-sm-12">
                            <div class="row g-3">
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Employee Code</label>
                                    <input class="form-control" type="text" v-model="emp.empcode"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Employee Name</label>
                                    <input class="form-control" type="text" v-model="emp.empname"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Employee Contact Number</label>
                                    <input class="form-control" type="text" @input="acceptNumberEmp"
                                        v-model="emp.contact" placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Employee Department</label>
                                    <select class="form-select" required="" v-model="emp.empdept">
                                        <option selected="" disabled="" value="">Choose...</option>
                                        <option v-for="(item, index)  in departments" :key="item.id" :value="item.id">{{
                                            item.deptname }}</option>
                                    </select>
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Employee Password</label>
                                    <input class="form-control" type="text" v-model="emp.emppwd"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Employee Role</label>
                                    <select class="form-select" required="" v-model="emp.emprole">
                                        <option selected="" disabled="" value="">Choose...</option>
                                        <option value="1">Admin</option>
                                        <option value="2">HOD</option>
                                        <option value="3">Employee</option>
                                        <option value="4">Security Admin</option>
                                    </select>
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Employee Status</label>
                                    <select class="form-select" required="" v-model="emp.empstatus">
                                        <option selected="" disabled="" value="">Choose...</option>
                                        <option value="1">Active</option>
                                        <option value="2">De-Active</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12">
                        <button class="btn btn-primary" @click="save_emp">Save Data</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="meetingroomAdd" tabindex="-1" role="dialog" aria-labelledby="meetingroomAdd"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Add Meeting Room</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper ">
                        <div class="col-sm-12">
                            <div class="row g-3">
                                <div class="col-md-12 position-relative">
                                    <label class="form-label">Meeting Room Name</label>
                                    <input class="form-control" type="text" v-model="room.name"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Meeting Room Status</label>
                                    <select class="form-select" required="" v-model="room.status">
                                        <option selected="" disabled="" value="">Choose...</option>
                                        <option value="1">Active</option>
                                        <option value="2">De-Active</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12">
                        <button class="btn btn-primary" @click="save_room">Add Meeting Room</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="gatepassAdd" tabindex="-1" role="dialog" aria-labelledby="gatepassAdd"
        aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Create Visitor Gatepass</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper">
                        <div class="col-sm-12">
                            <div class="row g-3">


                                <div class="col-md-3 col-12 position-relative">
                                    <label for="visitorfrmname" class="form-label">Visitor Firm Name</label>
                                    <input class="form-control" type="text" v-model="visitor.firmname"
                                        @input="filterFirmNames" @focus="showSuggestions = true" @blur="hideSuggestions"
                                        autocomplete="off" />
                                    <ul v-if="showSuggestions && filteredFirmNames.length"
                                        class="list-group position-absolute w-100" style="z-index: 1000;">
                                        <li v-for="(item, index) in filteredFirmNames" :key="index"
                                            class="list-group-item list-group-item-action"
                                            @mousedown.prevent="selectFirmName(item.firmname)">
                                            {{ item.firmname }}
                                        </li>
                                    </ul>
                                </div>



                                <div class="col-md-3  col-12 position-relative">
                                    <label class="form-label">Visit Purpose</label>
                                    <input class="form-control" type="text"
                                        @input="visitor.purpose = visitor.purpose.charAt(0).toUpperCase() + visitor.purpose.slice(1)"
                                        v-model="visitor.purpose" placeholder="Type Here..." required="">
                                </div>

                                <div class="col-md-3 col-12  position-relative">
                                    <label class="form-label">Visitor Address</label>
                                    <input class="form-control" type="text"
                                        @input="visitor.address = visitor.address.charAt(0).toUpperCase() + visitor.address.slice(1)"
                                        v-model="visitor.address" placeholder="Type Here..." required="">
                                </div>

                                <div class="col-md-3 col-12  position-relative">
                                    <label class="form-label">Schedule Date</label>
                                    <input class="form-control" type="date" v-model="visitor.schedule_date"
                                        placeholder="Type Here..." required="">
                                </div>

                                <!-- second--------------------------------------------- -->

                                <div class="row mt-2" v-for="(visitor_row_here, index) in visitors" :key="index">

                                    <div class="col-md-3 col-12 position-relative ">
                                        <label for="visitorname" class="form-label">Visitor Name</label>
                                        <input class="form-control" type="text" v-model="visitor_row_here.name"
                                            @input="filterNames(visitor_row_here)" @focus="typing_input(index)"
                                            @blur="hidenameSuggestions" autocomplete="off" />
                                        <ul v-if="shownameSuggestions && filteredNames.length && index==current_typing_visitor_count"
                                            class="list-group position-absolute w-100" style="z-index: 1000;">
                                            <li v-for="(item, index) in filteredNames" :key="index"
                                                class="list-group-item list-group-item-action"
                                                @mousedown.prevent="selectName(item.name,visitor_row_here)">
                                                {{ item.name }}
                                            </li>
                                        </ul>
                                    </div>


                                    <!-- <div class="col-md-4  col-12  position-relative">
                                    <label for="visitorname" class="form-label">Visitor Name</label>
                                    <select class="form-select form-select-sm" id="visitorname" ref="visitorname" v-model="visitor.name">
                                        <option v-for="(item, index) in visitorname" :key="index" :value="item.name">{{ item.name }}</option>
                                    </select>
                                </div>   -->

                                    <div class="col-md-4  col-12  position-relative">
                                        <label class="form-label">Visitor Contact Number</label>
                                        <input class="form-control" type="number" @input="acceptNumber"
                                            v-model="visitor_row_here.contact" :readonly="Visitor2ContactReadonly" placeholder="Type Here..." required="">
                                    </div>

                                    <div class="col-md-3  col-12  position-relative">
                                        <label class="form-label">Visitor Designation</label>
                                        <input class="form-control" type="text" :readonly="VisitorDesignationReadonly" v-model="visitor_row_here.designation"
                                            placeholder="Type Here..." required="">
                                    </div>

                                    <div class="col-md-1 mt-3 d-flex justify-content-center align-items-center">
                                        <button type="button" @click="addVisitor" class="btn btn-primary btn-sm p-1">
                                            <i class="icofont icofont-plus-square"></i>
                                        </button> &nbsp;&nbsp;
                                        <button v-if="index>0" type="button" @click="removeVisitor"
                                            class="btn btn-danger btn-sm p-1"> <i
                                                class="icofont icofont-trash"></i></button>
                                    </div>
                                </div>






                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12">
                        <button class="btn btn-primary" @click="save_visitor(0)">Save Data</button>
                        <button class="btn btn-primary" @click="save_visitor(1)">Save And Print</button>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- work permit------------------------------------------------------------------------------------------------------------>


    <div class="modal fade" id="workpermitAdd" tabindex="-1" role="dialog" aria-labelledby="workpermitAdd"
        aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Work Permit</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper">
                        <div class="col-sm-12">
                            <div class="row g-3">

                                <div class=col-12>
                                    <div class="card hovercard text-center mb-5"> 
                                            <video ref="video" autoplay ></video>
                                        
                                            <canvas ref="canvas" style="display: none"></canvas> 
                                            <div class="user-image">
                                            <div class="avatar"><img :src="photo" alt="Captured photo" class="img-100" v-if="photo" style="height: 100px;"></div>
                                        </div>
                                        </div>
                                        <button @click="capturePhoto" class="btn btn-primary">Capture Photo</button>
                                </div>

                                <div class="col-md-4 col-12 position-relative">
                                    <label for="workvisitorname" class="form-label">Visitor Name</label>
                                    <input class="form-control" type="text" v-model="workpermit.name"
                                        @input="filterVisitorNames" @focus="showSuggestionsvisitname = true"
                                        @blur="hidevisitnameSuggestions" autocomplete="off" />
                                    <ul v-if="showSuggestionsvisitname && filteredVisitorNames.length"
                                        class="list-group position-absolute w-100" style="z-index: 1000;">
                                        <li v-for="(item, index) in filteredVisitorNames" :key="index"
                                            class="list-group-item list-group-item-action"
                                            @mousedown.prevent="selectVisitorName(item)">
                                            {{ item.name }} / {{ item.contact }}
                                        </li>
                                    </ul>
                                </div>



                                <!-- <div class="col-md-4  col-12  position-relative">
                            <label for="workvisitorname" class="form-label">Visitor Name</label>
                            <select class="form-select form-select-sm" id="workvisitorname" ref="workvisitorname" v-model="workpermit.name">
                             
                                <option v-for="(item, index) in visitorname" :key="index" :value="item.id">{{ item.name }}</option>
                            </select>
                        </div> -->

                                <div class="col-md-4 col-12  position-relative">
                                    <label class="form-label">Company Name</label>
                                    <input class="form-control" type="text"  :readonly="companyNameReadonly" v-model="workpermit.companyname"
                                        placeholder="Type Here..." required="">
                                </div>

                                <div class="col-md-4 col-12  position-relative">
                                    <label class="form-label">Visitor Address</label>
                                    <input class="form-control" type="text"  :readonly="VisitorAddressReadonly" v-model="workpermit.address"
                                        placeholder="Type Here..." required="">
                                </div>


                                <div class="col-md-4  col-12  position-relative">
                                    <label class="form-label">Visitor Contact Number</label>
                                    <input class="form-control" type="number" :readonly="VisitorContactReadonly" maxlength="10" @input="acceptNumber"
                                        v-model="workpermit.contact" placeholder="Type Here..." required="">
                                </div>

                                <div class="col-md-4  col-12  position-relative">
                                    <label class="form-label">Visitor Designation</label>
                                    <input class="form-control" type="text" :readonly= "VisitorDesignationReadonly" v-model="workpermit.designation"
                                        placeholder="Type Here..." required="">
                                </div>

                                <div class="col-md-4  col-12  position-relative">
                                    <label class="form-label">Visitor Purpose</label>
                                    <input class="form-control" type="text" v-model="workpermit.purpose"
                                        placeholder="Type Here..." required="">
                                </div>


                                <div class="col-md-4  col-12  position-relative">
                                    <label class="form-label">Remark</label>
                                    <input class="form-control" type="text" v-model="workpermit.remark"
                                        placeholder="Type Here..." required="">
                                </div>

                                <div class="col-md-4 col-12  position-relative">
                                    <label class="form-label">From Date</label>
                                    <input class="form-control" type="date" v-model="workpermit.fromdate"
                                        placeholder="Type Here..." required="">
                                </div>


                                <div class="col-md-4 col-12  position-relative">
                                    <label class="form-label">To Date</label>
                                    <input class="form-control" type="date" v-model="workpermit.todate"
                                        placeholder="Type Here..." required="">
                                </div>

                                <div class="row" v-for="(workpermit_row, index) in workpermits" :key="index">


                                    <div class="col-md-3 col-12 position-relative mt-2">
                                        <label for="documentname" class="form-label">Document Name</label>
                                        <input class="form-control" type="text" v-model="workpermit_row.documentid"
                                            @input="filterDocumentNames(workpermit_row)" 
                                            @focus="workpermit_row.showdocSuggestions = true"
                                            @blur="hidedocSuggestions" autocomplete="off" />
                                        
                                        <ul v-if="workpermit_row.showdocSuggestions && workpermit_row.filtereddocuments?.length"
                                            class="list-group position-absolute w-100" style="z-index: 1000;">
                                            <li v-for="(item, i) in workpermit_row.filtereddocuments" :key="i"
                                                class="list-group-item list-group-item-action"
                                                @mousedown.prevent="selectdocumentName(item.name, workpermit_row)">
                                                {{ item.name }}
                                            </li>
                                        </ul>
                                    </div>



                                    <!-- <div class="col-md-4  col-12 mt-2 position-relative">
                                <label for="documentname" class="form-label">Document Name</label>
                                <select class="form-select form-select-sm" id="documentname" ref="documentname" v-model="workpermit.documentid">
                 
                                    <option v-for="(item, index) in documentlist" :key="index" :value="item.id">{{ item.name }}</option>
                                </select>
                            </div> -->

                            
                                    <div class="col-md-4 col-12 mt-2  position-relative">
                                        <label class="form-label">Expiry Date</label>
                                        <input class="form-control" type="date" v-model="workpermit_row.expirydate"
                                            placeholder="Type Here..." required="">
                                    </div>



                                    <div class="col-md-4 col-12 mt-2 position-relative">
                                        <label class="form-label">Select Documents</label>
                                        <input class="form-control" type="file" @change="onFileChange(workpermit_row)"  placeholder="Type Here..."
                                            required="">
                                    </div>


                                    <div class="col-md-1 mt-4 d-flex justify-content-center align-items-center">
                                        <button type="button" @click="addDocuments" class="btn btn-primary btn-sm p-1">
                                            <i class="icofont icofont-plus-square"></i>
                                        </button>&nbsp;&nbsp;
                                        <button v-if="index>0" type="button" @click="removeDocuments"
                                            class="btn btn-danger btn-sm p-1"><i
                                            class="icofont icofont-trash"></i></button>
                                    </div>

                                </div>




                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12">
                        <button class="btn btn-primary" @click="save_workpermit">Save Data</button>
                        <!-- <button class="btn btn-primary" @click="save_visitor(1)">Save And Print</button> -->
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- work permit------------------------------------------------------------------------------------------------------------->


    <!-- add documents---------------------------------------------------------------------------------------------------------------->



    <div class="modal fade" id="documentsAdd" tabindex="-1" role="dialog" aria-labelledby="documentsAdd"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Add Documents</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper ">
                        <div class="col-sm-12">
                            <div class="row g-3">
                                <div class="col-md-12 position-relative">
                                    <label class="form-label">Documents Name</label>
                                    <input class="form-control" type="text" v-model="documents.name"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Documents Status</label>
                                    <select class="form-select" required="" v-model="documents.status">
                                        <option selected="" disabled="" value="">Choose...</option>
                                        <option value="1">Active</option>
                                        <option value="2">De-Active</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12">
                        <button class="btn btn-primary" @click="save_documents">Add Documents</button>
                    </div>
                </div>
            </div>
        </div>
    </div>









    <!-- add documents----------------------------------------------------------------------------------------------------------------->









    <div class="modal fade" id="meetingroomBook" tabindex="-1" role="dialog" aria-labelledby="meetingroomBook"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Reserve Meeting Room</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper ">
                        <div class="col-sm-12">
                            <div class="row g-3">
                                <div class="col-md-3 position-relative " v-for="(item, index)  in rooms" :key="item.id">
                                    <div class="card bg-success ">
                                        <div class="card-body bg-success">
                                            <label class="form-label">{{item.roomname}}</label>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12 row">
                        <input class="form-control col-4" type="date" v-model="emp.empname" placeholder="Type Here..."
                            required="">
                        <div class="col-2"></div>
                        <button class="btn btn-primary  col-6" @click="reserve_room">Reserve Meeting Room</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="EmployeegatepassAdd" tabindex="-1" role="dialog" aria-labelledby="EmployeegatepassAdd"
        aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Create Employee Gatepass</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper">
                        <div class="col-sm-12">
                            <div class="row g-3">
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Select Authority</label>
                                    <select class="form-select" required="" v-model="emp_datepass.hod">
                                        <option v-for="(item, index)  in hods" :key="item.id" :value="item.id">{{
                                            item.empname }}</option>
                                    </select>
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Purpose</label>
                                    <input class="form-control" type="text" v-model="emp_datepass.purpose"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Schedule Checkout Time</label>
                                    <input class="form-control" type="time"
                                        v-model="emp_datepass.schedule_checkout_time" placeholder="Type Here..."
                                        required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Schedule Check In Time</label>
                                    <input class="form-control" type="time" v-model="emp_datepass.schedule_checkin_time"
                                        placeholder="Type Here..." required="">
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12">
                        <button class="btn btn-primary" @click="create_pass()">Submit Data</button>

                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="modal fade" id="vehicalReqAdd" tabindex="-1" role="dialog" aria-labelledby="vehicalReqAdd"
        aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Create Vehicle Request</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper">
                        <div class="col-sm-12">
                            <div class="row g-3">
                                <div class="col-md-6 d-flex position-relative">
                                    <div class="mb-3 d-flex gap-3 checkbox-checked">
                                        <div class="form-check">
                                            <input class="form-check-input" id="Local" value="Local" type="radio"
                                                v-model="vehicalReq.type">
                                            <label class="form-check-label mb-0" for="Local">Local</label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" id="Outstation" type="radio"
                                                v-model="vehicalReq.type" value="Outstation">
                                            <label class="form-check-label mb-0" for="Outstation">Outstation</label>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Select Authority</label>
                                    <select class="form-select" required="" v-model="vehicalReq.hod">
                                        <option v-for="(item, index)  in hods" :key="item.id" :value="item.id">{{
                                            item.empname }}</option>
                                    </select>
                                </div>
                                <div class="col-md-12 position-relative">
                                    <label class="form-label">Purpose</label>
                                    <input class="form-control" type="text" v-model="vehicalReq.purpose"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Source Location</label>
                                    <input class="form-control" type="text" v-model="vehicalReq.source"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Destination Location</label>
                                    <input class="form-control" type="text" v-model="vehicalReq.destination"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Schedule Checkout Date</label>
                                    <input class="form-control" type="date" v-model="vehicalReq.schedule_checkout_date"
                                        :min="vehicalReq.schedule_checkout_date" placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Schedule Checkout Time</label>
                                    <input class="form-control" type="time" v-model="vehicalReq.schedule_checkout_time"
                                        :min="vehicalReq.schedule_checkout_time" placeholder="Type Here..."  @change="vehicalinfo(vehicalReq.vehicle_id)" required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Schedule Check In Date</label>
                                    <input class="form-control" type="date" v-model="vehicalReq.schedule_checkin_date"
                                        :min="vehicalReq.schedule_checkin_date" placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Schedule Check In Time</label>
                                    <input class="form-control" type="time" v-model="vehicalReq.schedule_checkin_time"
                                        :min="vehicalReq.schedule_checkin_time" placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Select Vehicle</label>
                                    <select class="form-select" required="" v-model="vehicalReq.vehicle_id" @change="vehicalinfo(vehicalReq.vehicle_id)">
                                       <option value="0" selected disabled>SELECT VEHICLE</option>
                                        <option v-for="(item, index)  in vehicle_details" :key="item.id"
                                            :value="item.id">{{item.vehicle_details }}</option>
                                    </select>
                                </div>

                                <div v-if="vehical_info.length>0">
                                    <div class="table-responsive">
                                      <table class="table table-bordered table-striped">
                                        <thead class="thead-light">
                                          <tr>
                                            <th>#</th>
                                            <th>schedule Checkout </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr v-for="(item, index) in vehical_info" :key="item.id">
                                            <td>{{ index + 1 }}</td>
                                            <td>{{ item.schedule_checkout_date +"  "+ item.schedule_checkout_time }}</td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                  <div v-else>
                                    <span><strong>Available For Booking</strong></span>
                                    </div>
                                  

                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12">
                        <div v-if="vehicle_details>0">
                        <button class="btn btn-primary" @click="create_vehicle_req()" >Submit Data</button>
                        </div>
                        <div v-else>
                            <span class="text-danger"><strong>Please Add Vehicle First</strong></span>
                            </div>

                    </div>
                </div>
            </div>
        </div>
    </div>


    <div v-if="localVehicle" class="modal fade" id="vehicleAdd" tabindex="-1" role="dialog" aria-labelledby="vehicleAdd"
        aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Add Vehicle</h4>
                    <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="modal-toggle-wrapper">
                        <div class="col-sm-12">
                            <div class="row g-3">
                                <input class="form-control" type="hidden" v-model="localVehicle.id"
                                    placeholder="Type Here..." required="">
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Vehicle No</label>
                                    <input class="form-control" type="text" v-model="localVehicle.vehicle_no"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Contact Number</label>
                                    <input class="form-control" type="text" @input="acceptNumberVehicle"
                                        v-model="localVehicle.contact" placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Driver</label>
                                    <input class="form-control" type="text" v-model="localVehicle.driver_name"
                                        placeholder="Type Here..." required="">
                                </div>
                                <div class="col-md-6 position-relative">
                                    <label class="form-label">Vehicle Details</label>
                                    <input class="form-control" type="text" v-model="localVehicle.vehicle_details"
                                        placeholder="Type Here..." required="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12">
                        <button class="btn btn-primary" @click="save_vehicle">Save Data</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import axios from 'axios';
    export default {
        name: 'ModalsPart',
        props: {
            vehicle: Object,
            edit_emp_row: Array,
            edit_dept_row: Array,
            edit_document_row: Array,
            edit_meeting_row:Array,
        },
        emits: ["getDeptData", "getEmpData", "getVehicleData", "getRoomsData", "getGatePassData", "getGateEmpPassData", "getVehReqData", "getDocuemtsData","getworkpermitData"],
        mounted() {
            this.getBasics();
            var today = new Date();
            var month = today.getMonth() + 1;
            this.emp_datepass.schedule_checkout_time = ((today.getHours() < 10) ? '0' + today.getHours() : today.getHours()) + ":" + ((today.getMinutes() < 10) ? '0' + today.getMinutes() : today.getMinutes());// today.getMinutes() ;

            this.vehicalReq.schedule_checkout_time = (((2 + today.getHours()) < 10) ? '0' + (2 + today.getHours()) : (2 + today.getHours())) + ":" + ((today.getMinutes() < 10) ? '0' + today.getMinutes() : today.getMinutes());// today.getMinutes() ;
            this.vehicalReq.schedule_checkin_time = this.vehicalReq.schedule_checkout_time;//((today.getHours()<10)?'0'+today.getHours():today.getHours()) + ":" +((today.getMinutes()<10)?'0'+today.getMinutes():today.getMinutes());// today.getMinutes() ;

            this.vehicalReq.schedule_checkout_date = today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());//today.getDate();;
            this.vehicalReq.schedule_checkin_date = today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());//today.getDate();;
            this.vehicalReq.schedule_date = today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());//today.getDate();;

        },
        data() {
            return {
                showNewFields: false,
                emp: { "empname": '', "empcode": '', "empdept": '', "emppwd": '', "emprole": '', "empstatus": '', 'contact': '' },
                // vehicle: {"vehicle_no":'',"contact":'',"driver_name":'',"vehicle_details":''},
                localVehicle: {"vehicle_no":'',"contact":'',"driver_name":'',"vehicle_details":''},
                dept: { "name": '', "status": 1 },
                room: { "name": '', "status": 1 },
                visitor: { "name": '', "firmname": '', "contact": '', "address": '', "purpose": '', 'designation': '', 'schedule_date': this.todayDate() },
                workpermit: { "name": '', 'companyname': '', "contact": '', "address": '', 'designation': '', 'fromdate': this.todayDate(), 'todate': this.todayDate(), 'documentpath': '', 'documentid': '','purpose':'','remark':'','expirydate':''},
                emp_datepass: { "hod": 0, "purpose": '', 'designation': '', 'schedule_checkout_time': '', 'schedule_checkin_time': '' },
                vehicalReq: { "hod": 0, "vehicle_id": '', "type": 'Local', "purpose": '', 'source': '', 'destination': '', 'schedule_checkout_date': '', 'schedule_checkout_time': '', 'schedule_checkin_date': '', 'schedule_checkin_time': '' },
                iscalled: 0,
                departments: [],
                rooms: [],
                gatepass: [],
                visitorname: [],
                documentlist: [],
                filteredNames: [],
                filteredVisitorNames: [],
                filtereddocuments: [],
                vehical_info:[],

                visitorfirmname: [],
                filtered_visitorfirmname: [],// array of objects like { firmname: 'Company A' }
                filteredFirmNames: [], // ✅ Make sure this is initialized
                showSuggestions: false,
                hidedocSuggestions: false,
                showSuggestionsvisitname: false,
                shownameSuggestions: false,
                visitors: [
                    {
                        name: '',
                        contact: '',
                        designation: ''
                    }
                ],
                documents: [
                    {

                        name: '',
                        status: ''
                    }
                ],
                workpermits: [
                    {
                        documentpath: '',
                        documentid: '',
                        expirydate:''
                    }
                ],


                companyNameReadonly: false, // add this
                VisitorAddressReadonly:false,
                VisitorContactReadonly:false,
                VisitorDesignationReadonly:false,


                Visitor2ContactReadonly:false,

                visitorfirmname: [],
                myInstance: null,
                hods: [],
                select_hods:[],
                vehicle_details: [],
                localVehicle: { ...this.vehicle },
                current_typing_visitor_count: 0
            }
        },
        watch: {
            vehicle: {
                handler(newVal) {
                    this.localVehicle = { ...newVal }; // Sync the localVehicle whenever the parent prop changes
                },
                deep: true,
                immediate: true
            },

            edit_emp_row: {
                handler(newVal) {
                    this.emp = { ...newVal }; // Sync the localVehicle whenever the parent prop changes
                },
                deep: true,
                immediate: true
            },

            edit_dept_row: {
                handler(newVal) {
                    this.dept.name = newVal?.deptname??null;
                    this.dept.status = newVal?.deptstatus ??null;
                    this.dept.id = newVal?.id ??null;

                    //this.dept = { ...newVal }; // Sync the localVehicle whenever the parent prop changes
                },
                deep: true,
                immediate: true
            },

            edit_meeting_row: {
                handler(newVal) {
                    this.room.name = newVal?.roomname;
                    this.room.status = newVal?.roomstatus;
                    this.room.id = newVal?.id;

                    //this.dept = { ...newVal }; // Sync the localVehicle whenever the parent prop changes
                },
                deep: true,
                immediate: true
            },

            edit_document_row: {
                handler(newVal) {
                    this.documents.name = newVal?.name;
                    this.documents.status = newVal?.status;
                    this.documents.id = newVal?.id;

                    //this.dept = { ...newVal }; // Sync the localVehicle whenever the parent prop changes
                },
                deep: true,
                immediate: true
            }

        },
        methods: {
            addVisitor() {

                const lastVisitor = this.visitors[this.visitors.length - 1];

                if (
                    lastVisitor &&
                    (
                        String(lastVisitor.name).trim() === "" ||
                        String(lastVisitor.contact).trim() === "" ||
                        String(lastVisitor.designation).trim() === ""
                    )
                ) {
                    alert("Please fill in all fields before adding a new visitor.");
                    return;
                }


                this.visitors.push({
                    name: "",
                    contact: "",
                    designation: ""
                });
                //   this.$nextTick(() => {
                //     this.initializeSelect2(); // re-init Select2 on new elements
                // });
            },


            addDocuments() {


                const last = this.workpermits[this.workpermits.length - 1];

                    if (last && (last.documentpath === "" || last.documentid === "")) {
                        alert("Please fill out the previous document before adding a new one.");
                        return;
                    }


                this.workpermits.push({
                    documentpath: "",
                    documentid: "",
                    expirydate: "",
                });
            },



            removeVisitor(index) {
                this.visitors.splice(index, 1);
            },
            removeDocuments(index) {
                this.workpermits.splice(index, 1);
            },

            acceptNumber(event, index) {
                // only keep numbers
                const value = event.target.value.replace(/\D/g, "");
                this.visitors[index].contact = value;
            },

            todayDate() {
                var today = new Date();
                var month = today.getMonth() + 1;

                return today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());//today.getDate();;

            },
            acceptNumber() {
                var x = this.visitor.contact.replace(/\D/g, '').match(/(\d{0,10})/);
                this.visitor.contact = x[1];
                if (this.visitor.contact.length == 10) {
                    var self = this;
                    axios.post('getVisitor', { contact_no: this.visitor.contact }).then(function (response) {
                        if (response.data.is == 1)
                            self.visitor = response.data.user;
                        window.scrollTo(0, 0);
                    });
                }
            },
            acceptNumberEmp() {
                var x = this.emp.contact.replace(/\D/g, '').match(/(\d{0,10})/);
                this.emp.contact = x[1];

            },
            acceptNumberVehicle() {
                var x = this.localVehicle.contact.replace(/\D/g, '').match(/(\d{0,10})/);
                this.localVehicle.contact = x[1];

            },
            getBasics() {
                var self = this;
                axios.post('getDepartments').then(function (response) {
                    self.departments = response.data.departments;
                    self.rooms = response.data.rooms;
                    self.hods = response.data.hods; 
                    self.vehicle_details = response.data.vehicles;
                    self.visitorfirmname = response.data.visitorfirmname;
                    self.visitorname = response.data.visitorname;
                    self.filtered_visitorfirmname=self.visitorname;
                    self.documentlist = response.data.documentlist;
                    window.scrollTo(0, 0);
                })
                    .then(function () {


                        $("#visitorfrmname").select2({
                            width: '100%',
                            placeholder: "Search Visitor Firm Here...",
                            "language": {
                                "noResults": function () {
                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                }
                            },
                            escapeMarkup: function (markup) {
                                return markup;
                            }
                        }).on('change', function (event) {
                            const selectedId = $(this).val(); // gets the selected ID/value
                            self.visitor.firmname = selectedId; // store the ID in the visitor object

                        });





                        $("#visitorname").select2({
                            width: '100%',
                            placeholder: "Search Visitor Name Here...",
                            "language": {
                                "noResults": function () {
                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                }
                            },
                            escapeMarkup: function (markup) {
                                return markup;
                            }
                        }).on('change', function (event) {

                            const selectedId = $(this).val(); // gets the selected ID/value
                            // alert(selectedId); // correct case
                            self.visitor.name = selectedId; // store the ID in the visitor object
                            //  self.visitors[0].name = selectedId;


                        });

                        $("#workvisitorname").select2({
                            width: '100%',
                            placeholder: "Search Visitor Name Here...",
                            "language": {
                                "noResults": function () {
                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                }
                            },
                            escapeMarkup: function (markup) {
                                return markup;
                            }
                        }).on('change', function (event) {

                            const selectedId = $(this).val(); // gets the selected ID/value
                            // alert(selectedId); // correct case
                            self.workpermit.name = selectedId; // store the ID in the visitor object
                            //  self.visitors[0].name = selectedId;


                        });




                        $("#documentname").select2({
                            width: '100%',
                            placeholder: "Search Document Here...",
                            "language": {
                                "noResults": function () {
                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                }
                            },
                            escapeMarkup: function (markup) {
                                return markup;
                            }
                        }).on('change', function (event) {

                            const selectedId = $(this).val();
                            self.workpermit.documentid = selectedId;

                            // Update the first workpermit object in the array
                            if (self.workpermits.length > 0) {
                                self.workpermits[0].documentid = selectedId;
                            }

                            alert(selectedId);


                        });















                    });














            },
            save_visitor() {
                var self = this;

                if(self.visitor.firmname == ''){
                    self.$swal("Enter Firm Name");
                }else if(self.visitor.address == ''){
                    self.$swal("Enter Address");
                }else{

                const formData = new FormData();

                formData.append('visitors', JSON.stringify(self.visitors));

                // formData.append('name', self.visitor.name);
                formData.append('firmname', self.visitor.firmname);
                // formData.append('contact', self.visitor.contact); 
                formData.append('purpose', self.visitor.purpose);
                formData.append('schedule_date', self.visitor.schedule_date);
                formData.append('address', self.visitor.address);
                // formData.append('designation', self.visitor.designation); 



                axios.post('createGatePass', formData)
                    .then(response => {
                        var msg = '';
                        var gatepass_success = response.data.gatepass_success;
                        var visitor_success = response.data.visitor_success;

                        msg = response.data.visitor_statusmsg;
                        if (gatepass_success)
                            msg = response.data.gatepass_statusmsg;
                        self.visitor = { "name": '', "firmname": '', "contact": '', "purpose": '', 'schedule_date': new Date().toLocaleString() };

                        self.gatepass = response.data.gatepass;
                        if (print == 1)
                            window.open(window.location.origin + "/printpass?q=" + response.data.pass_id, '_blank');
                        else {
                            self.$swal(msg);
                            if (gatepass_success == 1) {
                                $("#gatepassAdd").modal("toggle");
                                self.$emit('getGatePassData', self.gatepass);
                                self.visitor = { "name": '', "firmname": '', "contact": '', "purpose": '', 'schedule_date': new Date().toLocaleString() };
                            }
                        }
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
                }

            },
            save_room() {
                var self = this;

             if(!self.room.name){
                self.$swal("Enter Name");
             }else{

                const formData = new FormData();
                formData.append('name', self.room.name);
                formData.append('status', self.room.status);
                formData.append('id', self.room.id ?? 0); 
                axios.post('addroom', formData)
                    .then(response => {
                        var msg = response.data.msg;
                        var isSuccess = response.data.status;
                        self.rooms = response.data.rooms;
                        self.$swal(msg);
                        if (isSuccess == 1) {
                            self.room={ "name": '', "status": 1 };
                            $("#meetingroomAdd").modal("toggle");
                            self.$emit('getRoomsData', self.rooms);
                        }
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
                }
            },
            save_dept() {
                var self = this;
              if(!self.dept.name){
                  self.$swal("Enter Department Name");
              }else{

                const formData = new FormData();
                formData.append('deptname', self.dept.name);
                formData.append('deptstatus', self.dept.status);
                formData.append('id', self.dept.id ?? 0);
                axios.post('adddepartment', formData)
                    .then(response => {
                        var msg = response.data.msg;
                        var isSuccess = response.data.status;
                        self.departments = response.data.departments;
                        self.$swal(msg);
                        if (isSuccess == 1) {
                            self.dept=  { "name": '', "status": 1 };
                            $("#departmentAdd").modal("toggle");
                            self.$emit('getDeptData', self.departments);
                        }
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
                }
            },
            save_emp() {
                var self = this;

              if(!self.emp.empname){

                self.$swal("Enter Employee Name");

              }else if(!self.emp.empcode){
                self.$swal("Enter Employee Code");
              
            }else if(!self.emp.emppwd){
                self.$swal("Enter Employee Password");
            }else if(!self.emp.contact){
                self.$swal("Enter Employee Contact");
            }else{


                const formData = new FormData();
                formData.append('empname', self.emp.empname);
                formData.append('empcode', self.emp.empcode);
                formData.append('empdept', self.emp.empdept);
                formData.append('emppwd', self.emp.emppwd);
                formData.append('emprole', self.emp.emprole);
                formData.append('empstatus', self.emp.empstatus);
                formData.append('contact', self.emp.contact);
                formData.append('id', self.emp.id??0);
                axios.post('add_employee', formData)
                    .then(response => {
                        var msg = response.data.msg;
                        var isSuccess = response.data.status;
                        self.employees = response.data.employees;
                        self.$swal(msg);
                        if (isSuccess == 1) {
                            self.emp= { "empname": '', "empcode": '', "empdept": '', "emppwd": '', "emprole": '', "empstatus": '', 'contact': '' },
                            $("#employeeAdd").modal("toggle");
                            self.$emit('getEmpData', self.employees);
                        }
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
                }
            },
            save_vehicle() {
                var self = this;
                if(!self.localVehicle.vehicle_no){
                    self.$swal("Enter Vehicle No");
                }else if(!self.localVehicle.driver_name){
                    self.$swal("Enter Drive Name");
                }else if(!localVehicle.vehicle_details){
                    self.$swal("Enter Vehicle Details");
                }else{
                const formData = new FormData();
                formData.append('vehicle_no', self.localVehicle.vehicle_no);
                formData.append('contact', self.localVehicle.contact);
                formData.append('driver_name', self.localVehicle.driver_name);
                formData.append('vehicle_details', self.localVehicle.vehicle_details);
                formData.append('vehicle_id', self.localVehicle.id);

                // Send request to backend
                axios.post('add_vehicle', formData)
                    .then(response => {
                        var msg = response.data.msg;
                        var isSuccess = response.data.status;
                        self.vehicles = response.data.vehicles;
                        self.$swal(msg);
                        if (isSuccess == 1) {
                            self.localVehicle={"vehicle_no":'',"contact":'',"driver_name":'',"vehicle_details":''}
                            $("#vehicleAdd").modal("toggle");
                            self.$emit('getVehicleData', self.vehicles);
                        }
                    })
                    .catch(error => {
                        console.log('Error during operation: ' + error);
                    });
                }
            }
            ,
            create_pass() {
                var self = this;
                if (self.emp_datepass.purpose.length == 0)
                    self.$swal("Please Enter Gatepass Purpose");
                if (self.emp_datepass.hod == 0)
                    self.$swal("Please Select HOD");
                else if (self.emp_datepass.schedule_checkout_time.length == 0)
                    self.$swal("Please Enter Check Out Time");
                else {
                    const formData = new FormData();
                    formData.append('purpose', self.emp_datepass.purpose);
                    formData.append('hod', self.emp_datepass.hod);
                    formData.append('schedule_checkout_time', self.emp_datepass.schedule_checkout_time);
                    formData.append('schedule_checkin_time', self.emp_datepass.schedule_checkin_time);

                    axios.post('createEmpGatePass', formData)
                        .then(response => {
                            var msg = '';
                            var gatepass_success = response.data.gatepass_success;

                            if (gatepass_success)
                                msg = response.data.gatepass_statusmsg;

                            self.gatepass = response.data.gatepass;


                            self.$swal(msg);
                            if (gatepass_success == 1) {
                                $("#EmployeegatepassAdd").modal("toggle");
                                self.$emit('getGateEmpPassData', self.gatepass);
                                self.emp_datepass = { "purpose": '', 'designation': '', 'schedule_checkout_time': '', 'schedule_checkin_time': '' };
                            }

                        })
                        .catch(error => {
                            console.log('Error on Authentication: ' + error);
                        });
                }
            },
            create_vehicle_req() {
                var self = this;
                if (self.vehicalReq.purpose.length == 0)
                    self.$swal("Please Enter Gatepass Purpose");
                else if (self.vehicalReq.source.length == 0)
                    self.$swal("Please Enter Source Location");
                else if (self.vehicalReq.destination.length == 0)
                    self.$swal("Please Enter Destination Location");
                else if (self.vehicalReq.hod == 0)
                    self.$swal("Please Select Authority To Request");
                else {
                    const formData = new FormData();
                    formData.append('hod_id', self.vehicalReq.hod);
                    formData.append('vehicle_id', self.vehicalReq.vehicle_id);
                    formData.append('purpose', self.vehicalReq.purpose);
                    formData.append('source', self.vehicalReq.source);
                    formData.append('req_type', self.vehicalReq.type);
                    formData.append('destination', self.vehicalReq.destination);
                    formData.append('schedule_checkout_date', self.vehicalReq.schedule_checkout_date);
                    formData.append('schedule_checkout_time', self.vehicalReq.schedule_checkout_time);
                    formData.append('schedule_checkin_date', self.vehicalReq.schedule_checkin_date);
                    formData.append('schedule_checkin_time', self.vehicalReq.schedule_checkin_time);


                    axios.post('createVehicalRequest', formData)
                        .then(response => {
                            var msg = '';
                            var req_success = response.data.req_success;

                            if (req_success)
                                msg = response.data.req_statusmsg;

                            if (req_success == 1) {
                                $("#vehicalReqAdd").modal("toggle");
                                self.vehicalReq = { "purpose": '', 'source': '', 'destination': '', 'schedule_checkout_date': '', 'schedule_checkout_time': '', 'schedule_checkin_date': '', 'schedule_checkin_time': '' };
                                self.$emit('getVehReqData', response.data.request);
                            }
                            self.$swal(msg);

                        })
                        .catch(error => {
                            console.log('Error on Authentication: ' + error);
                        });
                }
            },


            save_documents() {
                var self = this;
                if(!self.documents.name){
                    self.$swal("Enter Name");
                }else{
                const formData = new FormData();
                formData.append('name', self.documents.name);
                formData.append('status', self.documents.status);
                formData.append('id', self.documents.id ?? 0);  
                axios.post('adddocuments', formData)
                    .then(response => {
                        var msg = response.data.msg;
                        var isSuccess = response.data.status;
                        self.documents = response.data.documents;
                        self.$swal(msg);
                        if (isSuccess == 1) {
                            $("#documentsAdd").modal("toggle");
                            self.$emit('getDocuemtsData', self.documents);
                        }
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
                }
            },


            save_workpermit() {

                const blob = this.dataURLtoBlob(this.photo);

                var self = this;

           if(self.workpermit.name == ''){
           self.$swal("Enter name");
           }else if(self.workpermit.contact == ''){
            self.$swal("Enter Contact");
           }else{

                const formData = new FormData();

                formData.append('workpermits', JSON.stringify(self.workpermits));

                formData.append('name', self.workpermit.name);
                formData.append('workpermit', self.workpermit.workpermit);
                formData.append('contact', self.workpermit.contact);
                formData.append('address', self.workpermit.address);
                formData.append('designation', self.workpermit.designation);
                formData.append('fromdate', self.workpermit.fromdate);
                formData.append('todate', self.workpermit.todate);
                formData.append('companyname', self.workpermit.companyname);
                formData.append('purpose', self.workpermit.purpose);
                formData.append('remark', self.workpermit.remark);
                formData.append('image', blob, 'captured_photo.png');

                // Workpermit documents
                this.workpermits.forEach((item, index) => {
                    formData.append(`workpermits[${index}][documentid]`, item.documentid);
                    formData.append(`workpermits[${index}][documentpath]`, item.documentpath);
                    formData.append(`workpermits[${index}][expirydate]`, item.expirydate);
                });

                axios.post('createworkwisa', formData)
                    .then(response => {
                        var msg = response.data.message;

                        if (response.data.success == 1) {
                            self.$swal(msg);
                            $("#workpermitAdd").modal("toggle");
                            self.$emit('getworkpermitData', self.workpermit);
                        }



                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });

                }
            },

            onFileChange(workpermit_row) {
                const file = event.target.files[0];
                if (file) {
                    workpermit_row.documentpath = file;
                }
            },

            // for firm name--------------------------------------------------------
            filterFirmNames() {
                const search = this.visitor.firmname.toLowerCase();
                //   if(search=='')
                //     this.showSuggestions = false;
                //   else

                if (this.visitor.firmname.length > 0) {
                    this.visitor.firmname = this.visitor.firmname.charAt(0).toUpperCase() + this.visitor.firmname.slice(1);
                }


                this.showSuggestions = true;
                this.filteredFirmNames = this.visitorfirmname.filter(item =>
                    item.firmname.toLowerCase().includes(search)
                );
            },
            selectFirmName(name) {


                // axios.post('filternamebyfirm', { filter: name })
                //     .then(response => {
                //         var msg = '';
                //         self.visitorname = response.data.visitorname;

                //     })
                //     .catch(error => {
                //         console.log('Error on Authentication: ' + error);
                //     });





                this.filteredNames = this.visitorname.filter(item =>
                    item.firmname.toLowerCase().includes(name)
                );




                this.visitor.firmname = name;
                this.showSuggestions = false;
            },
            hideSuggestions() {
                //alert("hello");
                // Add delay so click registers before hiding
                setTimeout(() => {
                    this.showSuggestions = false;
                }, 100);
            },
            //for firm name-------------------------------------------------------------------

            // for visitor name-------------------------------------------------------------------------------------------------

            filterNames(visitor_row_here) {

             const search = visitor_row_here.name.toLowerCase();

                 


                

                this.filteredNames = this.visitorname.filter(item =>
                    item.name.toLowerCase().includes(search)
                );
                
                if(this.filteredNames && this.filteredNames.length >0)
                 this.shownameSuggestions = true;
                else
                 this.shownameSuggestions = false;


            },

            selectName(name, current_visitor) {
                current_visitor.name = name;
                let selected_visitor_row = this.visitorname.filter(item =>
                    item.name.toLowerCase().includes(name.toLowerCase())
                );
                console.log(selected_visitor_row);
                if (selected_visitor_row.length > 0) {
                    current_visitor.contact = selected_visitor_row[0].contact;
                    current_visitor.designation = selected_visitor_row[0].designation;
                    this.visitor.firmname = selected_visitor_row[0].firmname;
                    this.visitor.address = selected_visitor_row[0].address;
                }


                this.Visitor2ContactReadonly=true;
                this.VisitorDesignationReadonly=true;

                this.shownameSuggestions = false;
            },
            hidenameSuggestions() {
                // Add delay so click registers before hiding
                setTimeout(() => {
                    this.shownameSuggestions = false;
                }, 100);
            },


            // for visitor name-------------------------------------------------------------------------------------------------
    
            filterVisitorNames() {
                const search = this.workpermit.name.toLowerCase();



                this.showSuggestionsvisitname = true


                this.filteredVisitorNames = this.visitorname.filter(item =>
                    item.name.toLowerCase().includes(search)
                );
                
            },
            selectVisitorName(item) {
               
                this.workpermit.name = item.name;
                this.workpermit.companyname = item.firmname;
                this.workpermit.address = item.address;
                this.workpermit.contact = item.contact;
                this.workpermit.designation = item.designation;
                this.workpermit.purpose = item.purpose;
           
                this.showSuggestionsvisitname = false;
                this.companyNameReadonly = true; // make it readonly after selecting
                this.VisitorAddressReadonly=true;
                this.VisitorContactReadonly=true;
                this.VisitorDesignationReadonly=true;

            },
            hidevisitnameSuggestions() {
                // Add delay so click registers before hiding
                setTimeout(() => {
                    this.showSuggestionsvisitname = false;
                }, 100);
            },


            filterDocumentNames(current_row) {
        const search = current_row.documentid.toLowerCase();
        
        // Filter documents based on search
        current_row.filtereddocuments = this.documentlist.filter(item =>
            item.name.toLowerCase().includes(search)
        );

        current_row.showdocSuggestions = true;
    },

    selectdocumentName(name, current_row) {

        current_row.documentid = name;

        current_row.showdocSuggestions = false;
    },
    

    hidedocSuggestions(current_row) {
        setTimeout(() => {
            current_row.showdocSuggestions = false;
        }, 100);
    },

    vehicalinfo(id){
        var self = this;
        if(self.vehicalReq.vehicle_id){
                axios.post('getvehicalinfo',{id:self.vehicalReq.vehicle_id,for_date:self.vehicalReq.schedule_checkout_date}).then(function (response) {
                    self.vehical_info = response.data.vehical_info;
                    window.scrollTo(0, 0);
                })
                    .then(function () {

                    });

                }

    },







            typing_input(_index) {
                this.shownameSuggestions = true;
                this.current_typing_visitor_count = _index;
                // alert(this.current_typing_visitor_count);
            },







// photo upload------------------------------------------------------------------------------
async startWebcam() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        this.$refs.video.srcObject = stream;
      } catch (error) {
        console.error("Error accessing webcam:", error);
      }
    },
    capturePhoto() {
      const video = this.$refs.video;
      const canvas = this.$refs.canvas;
      const context = canvas.getContext('2d');

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      this.photo = canvas.toDataURL('image/png');
      this.save_workpermit();


    },
    dataURLtoBlob(dataURL) {
      const byteString = atob(dataURL.split(',')[1]);
      const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], { type: mimeString });
    },
// photo upload------------------------------------------------------------------------------



















        }
    }
</script>